import { Injectable } from '@angular/core';
import { HttpClientService } from './http-client.service';
import { CONFIG } from '../../environments/config';

@Injectable({
  providedIn: 'root'
})
export class PaymentReceiptService {

  constructor(private httpClientService: HttpClientService) { }

  public getPaymentReceiptNo() {
    return this.httpClientService.get(`${CONFIG.PAYMENTRECEIPT.AUTOGENERATE_PAYMENTRECEIPTNO}`);
  }

  public getPaymentTypes() {
    return this.httpClientService.get(`${CONFIG.PAYMENTRECEIPT.GET_PAYMENT_TYPES}`);
  }

  public getCreditCardTypes() {
    return this.httpClientService.get(`${CONFIG.PAYMENTRECEIPT.GET_CREDIT_CARD_TYPES}`);
  }

  public checkPayReceiptNo(ReceiptNo: string) {
    return this.httpClientService.get(`${CONFIG.PAYMENTRECEIPT.CHECK_PAY_RECEIPT_NO}?PaymentReceiptNo=${ReceiptNo}`);
  }

  public getOpenInvoiceList(data: any, customerCode: String) {
    return this.httpClientService.post(`${CONFIG.PAYMENTRECEIPT.GET_OPENINVOICE_BY_CUSTOMERCODE}?customerCode=${customerCode}`, data);
  }

  public createPaymentReceipt(data: any) {
    return this.httpClientService.post(`${CONFIG.PAYMENTRECEIPT.CREATE_PAYMENTRECEIPT}`, data);
  }

  public updatePaymentReceipt(data: any) {
    return this.httpClientService.post(`${CONFIG.PAYMENTRECEIPT.UPDATE_PAYMENTRECEIPT}`, data);
  }

  public createPaymentReceiptLineItem(data: any) {
    return this.httpClientService.post(`${CONFIG.PAYMENTRECEIPT.CREATE_PAYMENTRECEIPT_LINEITEM}`, data);
  }

  public createPaymentReceiptLineItems(paymentReceiptId: number, data: any[]) {
    return this.httpClientService.post(`${CONFIG.PAYMENTRECEIPT.CREATE_PAYMENTRECEIPT_LINEITEMS}/${paymentReceiptId}`, data);
  }

  public updatePaymentReceiptStatus(data: any) {
    return this.httpClientService.post(`${CONFIG.PAYMENTRECEIPT.UPDATE_PAYMENTRECEIPT_STATUS}`, data);
  }

  public getAdvanceCustomerPayments(customerId: number) {
    return this.httpClientService.get(`${CONFIG.PAYMENTRECEIPT.GET_ADVANCE_CUSTOMER_PAYMENTS}?customerId=${customerId}`);
  }

  public applyCustomerCredits(data: any) {
    return this.httpClientService.post(`${CONFIG.PAYMENTRECEIPT.APPLY_CUSTOMER_CREDITS}`, data);
  }

  public getAppliedCustomerCreditsByInvoice(invoiceNo: string) {
    return this.httpClientService.get(`${CONFIG.PAYMENTRECEIPT.GET_APPLIED_CUSTOMER_CREDITS}?invoiceNo=${invoiceNo}`);
  }

  public getUnprocessedPaymentSum(invoiceNo: string) {
    return this.httpClientService.get(`${CONFIG.PAYMENTRECEIPT.GET_UNPROCESSED_PAYMENT_SUM}?invoiceNo=${encodeURIComponent(invoiceNo)}`);
  }

  public getUnprocessedPaymentSumsByCustomer(customerCode: string, excludePaymentReceiptId?: number) {
    let url = `${CONFIG.PAYMENTRECEIPT.GET_UNPROCESSED_PAYMENT_SUMS_BY_CUSTOMER}?customerCode=${encodeURIComponent(customerCode)}`;
    if (excludePaymentReceiptId != null && excludePaymentReceiptId > 0) {
      url += `&excludePaymentReceiptId=${excludePaymentReceiptId}`;
    }
    return this.httpClientService.get(url);
  }

  public voidPaymentReceipt(data: { entityId: number; entityCode: string; reason: string; voidedBy: string }) {
    return this.httpClientService.post(`${CONFIG.PAYMENTRECEIPT.VOID_PAYMENT_RECEIPT}`, data);
  }

  public glPostPaymentReceipt(paymentReceiptId: number, body: { createdBy: string }) {
    return this.httpClientService.post(`${CONFIG.PAYMENTRECEIPT.GL_POST_PAYMENT_RECEIPT}/${paymentReceiptId}`, body);
  }

  public getGlEntriesForPaymentReceipt(paymentReceiptId: number) {
    return this.httpClientService.get(`${CONFIG.PAYMENTRECEIPT.GL_ENTRIES_PAYMENT_RECEIPT}/${paymentReceiptId}`);
  }

  public getPRList(data: any) {
    return this.httpClientService.post(`${CONFIG.PAYMENTRECEIPT.GET_PAYMENTRECEIPT_LIST}`, data);
  }

  public getPriorPaidListByInvoiceNo(InvoiceNo: string) {
    return this.httpClientService.get(`${CONFIG.PAYMENTRECEIPT.GET_PAYMENTRECEIPT_BY_INVOICENO}?InvoiceNo=${InvoiceNo}`);
  }

  public getTermByCustomer(CustomerCode: string) {
    return this.httpClientService.get(`${CONFIG.CUSTOMER.GET_TERMS_BY_CUSTOMER}?customerCode=${CustomerCode}`);
  }

  public getPaymentReceiptById(PaymentReceiptId: number) {
    return this.httpClientService.get(`${CONFIG.PAYMENTRECEIPT.GET_PAYMENTRECEIPT_BY_ID}?id=${PaymentReceiptId}`);
  }

  public getPRLineItemByPRNo(PaymentReceiptNo: string, includeInactive = false) {
    const flag = includeInactive ? '&includeInactive=true' : '';
    return this.httpClientService.get(`${CONFIG.PAYMENTRECEIPT.GET_PAYMENTRECEIPT_LINEITEM_BY_PRNO}?id=${encodeURIComponent(PaymentReceiptNo)}${flag}`);
  }

  public getPRLineItemsByPaymentReceiptId(paymentReceiptId: number, includeInactive = false) {
    const flag = includeInactive ? '&includeInactive=true' : '';
    return this.httpClientService.get(`${CONFIG.PAYMENTRECEIPT.GET_PAYMENTRECEIPT_LINEITEM_BY_ID}?id=${paymentReceiptId}${flag}`);
  }

  public getPaymentCollections(data: any, customerCode: string, status: string = 'All') {
    return this.httpClientService.post(`${CONFIG.PAYMENTRECEIPT.GET_PAYMENT_COLLECTIONS}?customerCode=${customerCode}&Status=${status}`, data);
  }

  public SearchPaymentReceipt(seachkey: string) {
    return this.httpClientService.get(`${CONFIG.PAYMENTRECEIPT.SEARCH_PAYMENT_RECEIPT}?searchText=${seachkey}`);
  }

  public getBanks(data: any) {
    return this.httpClientService.post(`${CONFIG.PAYMENTRECEIPT.GET_BANKS}`, data);
  }
}
